import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

export function useProtocolEmails(protocolId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["protocol", protocolId ?? "--", "emails"],
		queryFn: async () => {
			if (!protocolId) throw new Error("No protocol ID");
			const response = await client.protocols[":protocolId"].emails.$get({
				param: { protocolId },
			});
			const data = await responseHandler(response);
			return data.protocolEmails;
		},
		enabled: !!protocolId,
	});

	/** Return */
	return { ...query, protocolEmails: query.data };
}
